<template>
  <div class="institutionDetail">
    <!-- 头部简单信息 -->
    <div class="detail-head">
      <div class="avator">
        <el-avatar :size="100" :src="circleUrl"></el-avatar>
        <span class="camera">
          <img class="cameraIcon" :src="cameraIcon" alt="" srcset="" />
        </span>
      </div>
      <div class="info-keys">
        <div>商户名称:</div>
        <div style="padding: 16px 0">账号ID:</div>
        <div>注册时间:</div>
      </div>
      <div class="info-values">
        <div>{{ detailInfo.name || "-" }}</div>
        <div style="padding: 18px 0">{{ detailInfo.code || "-" }}</div>
        <div>{{ detailInfo.created_at || "-" }}</div>
      </div>
      <div class="info-keys">
        <div>商户类型:</div>
        <div style="padding: 16px 0">联系人:</div>
      </div>
      <div class="info-values">
        <div>
          {{ detailInfo.type || "-"
          }}<span
            v-permission="'merchant_type'"
            class="detail-edit"
            @click="editOption('type')"
            >修改</span
          >
        </div>
        <div style="padding: 16px 0">
          {{ detailInfo.head || "-" }}
          <span
            v-permission="'merchant_contact'"
            class="detail-edit"
            @click="editOption('head')"
            >{{ detailInfo.head ? "修改" : "设置" }}</span
          >
        </div>
      </div>
    </div>
    <!-- 基础信息和业务设置 -->
    <div class="detail-body">
      <div class="type-buttons">
        <span
          class="type-button"
          :class="checked === 'baseInfo' ? 'active-button' : ''"
          @click="checkButton('baseInfo')"
          >基础信息</span
        >
        <span
          class="type-button"
          :class="checked === 'businessSetting' ? 'active-button' : ''"
          @click="checkButton('businessSetting')"
          >业务设置</span
        >
      </div>
      <!-- 基础信息 -->
      <div class="base-info" v-show="checked === 'baseInfo'">
        <div class="detail-item">
          <span class="item-title">联系电话</span>
          <span class="item-content">
            <span class="content-info">{{
              detailInfo.mobile || "未设置"
            }}</span>
            <span
              v-permission="'merchant_phone'"
              class="content-edit"
              @click="editOption('mobile')"
              >{{ detailInfo.mobile ? "修改" : "设置" }}</span
            >
          </span>
        </div>
        <div class="detail-item">
          <span class="item-title">商户邮箱</span>
          <span class="item-content">
            <span class="content-info">{{ detailInfo.email || "未设置" }}</span>
            <span
              v-permission="'merchant_email'"
              class="content-edit"
              @click="editOption('email')"
              >{{ detailInfo.email ? "修改" : "设置" }}</span
            >
          </span>
        </div>
      </div>
      <!-- 业务设置 -->
      <div class="bussiness-setting" v-show="checked === 'businessSetting'">
        <div class="detail-item">
          <span class="item-title">商户密匙</span>
          <span class="item-content">
            <span class="content-info">{{ detailInfo.platformKey }}</span>
            <span v-permission="'merchant_key'" class="content-edit">查看</span>
          </span>
        </div>
        <div class="detail-item">
          <span class="item-title">对接模式</span>
          <span class="item-content">
            <span class="content-info">
              <span
                v-for="(item, index) in mode"
                :key="index"
                style="padding-right: 10px"
                >{{ item }}</span
              >
            </span>
            <span
              v-permission="'merchant_config'"
              class="content-edit"
              @click="editOption('mode')"
              >修改</span
            >
          </span>
        </div>
      </div>
    </div>
    <!-- 修改弹窗 -->
    <el-dialog
      :title="dialogTitle"
      width="25%"
      top="30vh"
      :center="true"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      @close="clearDialog"
    >
      <el-form :model="dialogValue" :rules="rules" ref="ruleForm">
        <el-form-item
          label="联系人"
          prop="value"
          label-width="80px"
          v-if="dialogType === 'head'"
        >
          <el-input
            v-model="dialogValue.value"
            autocomplete="off"
            placeholder="请输入联系人"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="商户类型"
          prop="value"
          label-width="80px"
          v-if="dialogType === 'type'"
        >
          <el-select v-model="dialogValue.value">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="联系电话"
          prop="value"
          label-width="80px"
          v-if="dialogType === 'mobile'"
        >
          <el-input
            v-model="dialogValue.value"
            autocomplete="off"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="邮箱"
          prop="value"
          label-width="80px"
          v-if="dialogType === 'email'"
        >
          <el-input
            v-model="dialogValue.value"
            autocomplete="off"
            placeholder="请输入邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="对接模式"
          prop="value"
          label-width="80px"
          v-if="dialogType === 'mode'"
        >
          <el-checkbox-group v-model="dialogValue.value">
            <el-checkbox label="云云对接" name="mode"></el-checkbox>
            <el-checkbox label="设备对接" name="mode"></el-checkbox>
            <el-checkbox label="其他" name="mode"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { businessDetail, businessOptionEdit } from "@/api/institutionApi";
export default {
  data() {
    return {
      circleUrl: require("@/assets/images/useravatar@2x.png"),
      cameraIcon: require("@/assets/images/camera@2x.png"),
      // 选中按钮
      checked: "baseInfo",
      // 商户详细信息
      detailInfo: {},
      // 商户类型下拉列表
      options: [],
      // 对接模式
      mode: [],
      // 弹窗开关
      dialogFormVisible: false,
      // 弹窗类型
      dialogType: "",
      // 标题对照表
      title: {
        head: "修改联系人",
        mobile: "修改联系电话",
        email: "修改邮箱",
        type: "修改商户类型",
        mode: "修改对接模式",
      },
      // 弹窗标题
      dialogTitle: "",
      // 弹窗内容回显
      dialogValue: {
        value: "",
      },
      // 校验
      rules: {
        value: [],
      },
    };
  },
  computed: {
    editFlag() {
      // 编辑配置项权限
      return (
        this.$store.state.userInfo.permissions.includes(
          "businessEditConfigure"
        ) || this.$store.getters.isAdmin
      );
    },
  },
  created() {
    this.getDetail();
  },
  methods: {
    // 获取商户详情
    async getDetail() {
      const { data } = await businessDetail({
        id: this.$route.query.id,
      });
      if (data.code === 1000) {
        this.detailInfo = data.data.data;
        // 商户类型解析
        this.options = JSON.parse(localStorage.getItem("institutionType"));
        this.detailInfo.type = this.options.find(
          (item) => item.value === data.data.data.type
        ).label;
        // 对接模式解析
        const mapping = {
          1: "云云对接",
          2: "设备对接",
          3: "其他",
        };
        this.mode = data.data.data.docking_mode.map((item) => mapping[item]);
      } else {
        this.$message.error(data.msg);
      }
    },
    // 切换选中按钮
    checkButton(type) {
      this.checked = type;
    },
    // 打开编辑弹窗
    editOption(params) {
      // if (this.editFlag) {
      this.dialogType = params;
      this.dialogFormVisible = true;
      this.dialogTitle = this.title[params];
      params === "mode"
        ? (this.dialogValue.value = this.mode)
        : (this.dialogValue.value = this.detailInfo[params]);
      // }
      // console.log(this.detailInfo[params]);
    },
    // 提交修改
    async submitEdit() {
      let params;
      switch (this.dialogType) {
        case "head":
          params = { head: this.dialogValue.value };
          break;
        case "mobile":
          params = { mobile: this.dialogValue.value };
          break;
        case "email":
          params = { email: this.dialogValue.value };
          break;
        case "type":
          params = { type: this.dialogValue.value };
          break;
        case "mode":
          // 对接模式传参修改
          const mapping = {
            云云对接: 1,
            设备对接: 2,
            其他: 3,
          };
          const mode = this.dialogValue.value.map((item) => mapping[item]);
          params = { docking_mode: mode };
          break;
      }
      const { data } = await businessOptionEdit({
        _id: this.$route.query.id,
        ...params,
      });
      if (data.code === 1000) {
        this.dialogFormVisible = false;
        this.getDetail();
      } else {
        this.$message.error(data.msg);
      }
    },
    // 弹窗关闭
    clearDialog() {
      this.dialogValue.value = "";
    },
  },
};
</script>

<style lang="less" scoped>
.institutionDetail {
  width: 100%;
  height: 100% - 30px;
  // background-color: #fff;
  .detail-head {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    height: 174px;
    padding-left: 40px;
    background-color: #fff;
    .avator {
      position: relative;
      width: 100px;
      height: 100px;
      .camera {
        display: inline-block;
        position: absolute;
        bottom: 0;
        right: 0;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background-color: #f2f3f5;
        .cameraIcon {
          width: 18px;
          height: 18px;
          padding-top: 7px;
          padding-left: 7px;
        }
      }
    }
    .info-keys {
      text-align: right;
      width: 156px;
      color: #86909c;
    }
    .info-values {
      width: 224px;
      padding-left: 16px;
      .detail-edit {
        color: #165dff;
        padding-left: 16px;
        cursor: pointer;
      }
    }
  }
  .detail-body {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    margin-top: 16px;
    padding: 20px;
    background-color: #fff;
    .type-button {
      display: inline-block;
      width: 88px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      border-radius: 16px;
      margin-right: 12px;
      color: #4e5969;
      cursor: pointer;
    }
    .active-button {
      color: #165dff;
      background-color: #f2f3f5;
    }
    .detail-item {
      display: flex;
      padding-top: 40px;
      .item-title {
        width: 56px;
        padding-left: 20px;
        padding-right: 16px;
      }
      .item-content {
        flex: 1;
        display: flex;
        justify-content: space-between;
        margin-right: 24px;
        padding-bottom: 30px;
        border-bottom: 1px solid #e5e6eb;
        .content-info {
          color: #86909c;
        }
        .content-edit {
          color: #165dff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
